import styled from 'styled-components'
import { Card, Row } from 'antd'
import { Title } from 'src/components/Ant'

export const ContainerImage = styled.a`
  margin-right: 16px;
`

export const ContainerInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`

export const ContainerExchangeRate = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;

  .ant-typography {
    margin-right: 8px;
  }
`

export const Cost = styled(Title)`
  color: #229552 !important;
  margin: 0 !important;
`

export const WrapCard = styled(Card)`
  margin-bottom: 16px;
`

export const WrapRow = styled(Row)`
  margin: 12px 16px 0 16px !important;
`
